import * as actionTypes from "../Actions/action-types";
const initialState = {
  status: false,
  allOutlets: [],
  isLoadingO: true,
  errorO: false,
  trainName:"",
  doj:"",
  trainNO:"",
  pnr:""
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_OUTLETS:
      console.log("isloading false");
      return {
        ...state,
        allOutlets: action.allOutlets,
        isLoadingO: false,
        error: false,
        status: true,
        trainName:action.trainName,
        trainNO:action.trainNO,
        doj:action.doj,
        pnr:action.pnr
      };
    case actionTypes.FETCHED_OUTLETS_FAILS:
      return {
        ...state,
        errorO: true,
        isLoadingO: false,
        status: false
      };
    case actionTypes.STATUS_CHANGE:
      return {
        ...state,
        errorO: false,
        status: true
      };
    case actionTypes.IS_LOADING_OUTLETS:
      return {
        ...state,
        isLoadingO: true
      };
    case actionTypes.NOT_LOADING:
      return {
        ...state,
        isLoadingO: false
      };
    case actionTypes.RESETOUTLETS:
      return {
        status: false,
        allOutlets: [],
        isLoadingO: true,
        errorO: false,
        trainName:"",
        doj:"",
        trainNO:"",
        pnr:""
        
      };
    default:
      return state;
  }
};
export default reducer;
